// todo: 后面modal都用这里的

import { Modal, type ModalFuncProps } from 'ant-design-vue'
import type { ModalFunc } from 'ant-design-vue/es/modal/Modal'
import { useXModal } from '~/composables/modal'

export const XModal = defineComponent({
  setup() {
    const xmodal = useXModal()
    return () => {
      return (
        <>
          {xmodal.value.map((item) => {
            return item()
          })}
        </>
      )
    }
  },
})

export function confirm(
  options: ModalFuncProps
): Promise<ReturnType<ModalFunc>> {
  const xmodal = useXModal()
  const [api, ContextHolder] = Modal.useModal()

  xmodal.value.push(ContextHolder)

  function removeContext() {
    xmodal.value = xmodal.value.filter((item) => item !== ContextHolder)
  }

  return nextTick(() => {
    const oldAfterClose = options.afterClose

    const modal = api.confirm(
      Object.assign(options, {
        afterClose() {
          oldAfterClose?.()
          removeContext()
        },
      } as ModalFuncProps)
    )

    return modal
  })
}
